export const Logo = ({ compact = false, big = false }) => (
  <span className="flex items-center" data-testid="brand-logo">
    <img
      src="/concorde-logo.jpg"
      alt="Concorde Auto Acceptance"
      className={`${big ? "h-14" : compact ? "h-9" : "h-11"} w-auto rounded-md border border-white/10 object-cover`}
    />
  </span>
);

export default Logo;
